<mat-spinner *ngIf="loading"></mat-spinner>
<div *ngIf="!loading">

    <iframe style="width: 100%;" height="500" *ngIf="getSafeResourceUrl()" [src]="getSafeResourceUrl()" type="application/pdf"></iframe>

</div>
<div class="clearfix">
    <div class="pull-right">
        <button *ngIf="!loading" mat-button type="button" cdkFocusInitial (click)="confirm()">Confirmar liquidación</button>
        <button *ngIf="!loading" mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
    </div>
</div>